
export const PAGE_TYPE = {
    PAGE_ABOUT: 'about',
    PAGE_OFFERS: 'offers',
    PAGE_WHAT_NEW: 'features'
};

export const LANDING_HEADER_LIST = [
    // {
    //     name: 'whatsNew',
    //     title: "Features in JioAICloud",
    //     link: 'https://static.jiocloud.com/info/info.html',
    //     redirectionUrl:'/features'
    // },
    /*{
        name: 'enterprise',
        title: "JioAICloud Enterprise",
        link: '/enterprise/about',
        redirectionUrl:'/enterprise/about'
    },*/
    {
        name: 'pricing',
        title: "Buy Storage",
        link: '/pricing',
        redirectionUrl:'/pricing'
    },
    {
        name: 'home',
        title: 'Home',
        link: '/',
        target: '_self',
        redirectionUrl:'/'
    },
    {
        name: 'downloads',
        title: 'Go to JioAICloud Downloads',
        link: '/downloadApp',
        target: '_self',
        redirectionUrl:'/downloadApp'
    },
    {
        name: 'frequently asked questions',
        title: "Frequently asked questions",
        link:  '/help/home',
        redirectionUrl:  '/help/home',
        target: '_self'
    },

    // {
    //     name: 'How to Videos',
    //     title: "How to Videos",
    //     link: '/how-to-videos/faq',
    //     target: '_blank'
    // },
    // {
    //     name: 'offers',
    //     title: 'Go to JioAICloud Offers',
    //     link: 'https://static.jiocloud.com/referandearn.html',
    //     target: '_blank'
    // },
    // {
    //     name: 'Terms of Service',
    //     title: "Terms of Service",
    //      redirectionUrl:  'https://static.jiocloud.com/tos.html',
    //     link: 'https://static.jiocloud.com/tos.html',
    //     target: '_self'
    // },

    {
        name: 'JioTransfer',
        title: 'Go to JioTransfer',
        link: '',
        target: '_blank'
    },
    // {
    //     name: 'contactUs',
    //     title: "Contact us",
    //     link: 'mailto:care.jioaicloud@jio.com',
    //     redirectionUrl:'mailto:care.jioaicloud@jio.com',
    //     target: '_self'
    // }
    // {
    //     name: 'privacy policy',
    //     title: "Privacy Policy",
    //     link: 'https://static.jiocloud.com/privacypolicy.html',
    //     target: '_self'
    // }
];
export const MOBILE_LANDING_HEADER_LIST = [
    // {
    //     name: 'whatsNew',
    //     title: "Features in JioAICloud",
    //     link: 'https://static.jiocloud.com/info/info.html',
    //     target: '_blank',
    //     redirectionUrl:'/features'
    // },
    /*{
        name: 'enterprise',
        title: "JioAICloud Enterprise",
        link: '/enterprise/about',
        redirectionUrl:'/enterprise/about'
    },*/
    // {
    //     name: 'offers',
    //     title: 'Go to JioAICloud Offers',
    //     link: 'https://static.jiocloud.com/referandearn.html',
    //     target: '_blank'
    // },
    {
        name: 'home',
        title: 'Home',
        link: '/',
        target: '_self',
        redirectionUrl:'/'
    },
    {
        name: 'downloads',
        title: 'Go to JioAICloud Downloads',
        link: '/downloadApp',
        target: '_self',
        redirectionUrl:'/downloadApp'
    },
    {
        name: 'frequently asked questions',
        title: "Frequently asked questions",
        link:  '/help/home',
        redirectionUrl:  '/help/home',
        target: '_self'
    },

    // {
    //     name: 'JioTransfer',
    //     title: 'Go to JioTransfer',
    //     link: '',
    //     target: '_blank'
    // },
];


export const THEMES = {
    THEME_LIGHT: 'light',
    THEME_DARK: 'light' //to remove dark theme from landing page task - 505714
  };
  
  export const LANGUAGE_SUPPORT = [
    {
        name: 'English',
        code: 'en-US'
    },
    {
        name: 'हिंदी',
        code: 'hi-IN'
    }
  ];
  
  export const SUNSET_SUNRISE = {
      SUNRISE: 7,
      SUNSET: 19
  };
  